class BESSAppProjectEditorManagerBase extends BESSAppBase {

    constructor(editor) {
        super();
        this.editor = editor;
        this.saveFn = null;
        this.totalItemTemplate = new Template('' +
            '<div><div class="app-total-item"><span class="app-total-amount"></span><span class="app-total-what"></span></div></div>');
        this._forEachItem(this.manageItem);
    }

    onRebuild() {
        this._forEachItem(this.manageItem);
    }

    isValid() {
        return true;
    }

    updateState() {

    }

    saved(result) {
        return true;
    }

    _createTotalItemContent(total, what) {
        return this.totalItemTemplate.build({
            values: {
                '.app-total-amount': total,
                '.app-total-what': what,
            }
        }).html();
    }

    _forEachItem(fn) {
        _.each(this.editor.items, fn.bind(this));
    }

    manageItem(item) {
    }

    onInputChanged(input, value) {

    }

    standardiseMunicipality(municipality, postfix) {
        municipality = municipality.replace('City of', '').replace('City Council', '');
        municipality = municipality.trim();
        if (municipality === 'Moreland') {
            municipality = 'Merri-bek';
        }
        municipality = municipality + ' ' + postfix;
        console.log("municipality=" + municipality);
        return municipality;
    }

    getItemFor(itemData) {
        let match = null;
        this._forEachItem(function (item) {
            if (item.itemData === itemData) {
                match = item;
            }
        })
        return match;
    }

    addedNewItem(item) {

    }
}